import { Payload } from "@utils/http/AxiosAPI";
import { IMSTokenParams, putWithIdToken } from "@utils/http/MSAuthAPI";
import {logger as SentryLogger} from '@sentry/react';

export type VehicleExchangeRequest = { exchangeDocumentId: string };

export interface ExchangeResponseFleetioDetail {
    success_old: boolean;
    vehicle_url_old: string;
    vehicle_description_old: string;
    success_new: boolean;
    vehicle_url_new: string;
    vehicle_description_new: string;
}

export interface ExchangeResponseZohoDetail {
    success: boolean;
    subscription_url: string;
    contact_email: string;
    contact_id: string;
}

export interface ExchangeResponseChargebeeDetail {
    success: boolean;
    subscription_url?: string;
}

export enum ExchangeType {
    Permanent = "Permanent",
    Temporary = "Temporary"
}

export interface VehicleExchangeResponse {
    exchange_type: ExchangeType;
    fleetio: ExchangeResponseFleetioDetail;
    zoho: ExchangeResponseZohoDetail;
    chargebee?: ExchangeResponseChargebeeDetail;
    possible_incorrect_original_vehicle_data: boolean;
}

interface IVehicleExchangeService {
    performVehicleExchange(
        body: VehicleExchangeRequest,
        IDTokenParams: IMSTokenParams
    ): Promise<VehicleExchangeResponse>;
}

export const VehicleExchangeService: IVehicleExchangeService = {
    async performVehicleExchange(body, IDTokenParams) {
        const resp = await putWithIdToken(
            "v1/vehicle-exchange",
            IDTokenParams,
            {}, // no query params
            body
        );
        SentryLogger.info("Exchange result", { request: body, response: resp.data });
        return resp.data;
    }
};
